/**
 * UI / robot-service string values for motor spin direction.
 * These literals must stay aligned with framework `MotorDirection` in Python
 * (`MotorDirection.FORWARD` / `MotorDirection.REVERSE`).
 */
export const MOTOR_DIRECTION = {
  forward: 'forward',
  reverse: 'reverse',
} as const;

export type MotorDirection = (typeof MOTOR_DIRECTION)[keyof typeof MOTOR_DIRECTION];

/** Parse stored framework text (e.g. `MotorDirection.REVERSE`) into a UI direction. */
export function parseMotorDirectionSetting(value: string | undefined | null): MotorDirection {
  if (value == null || value === '') {
    return MOTOR_DIRECTION.forward;
  }
  const normalized = String(value).toUpperCase();
  return normalized.includes('REVERSE') ? MOTOR_DIRECTION.reverse : MOTOR_DIRECTION.forward;
}
